import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hello',
  template: `<p>
  Hello From Library Component
</p>
`,
  styles: [``]
})
export class HelloComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
